module.exports = __webpack_public_path__ + "img/case.c37861fa.png";